import { ROLE } from 'api/entities/user'
import { Statistic } from 'modules/admin/components'
import { selectAuth } from 'modules/auth/slice'
import { Info } from 'modules/me/components'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'

export const Main: FC = () => {
  const { consoleFor } = useSelector(selectAuth)

  if (consoleFor === ROLE.ADMIN) {
    return (<Statistic />)
  }

  return (
    <Info />
  )
}
